// extracted by mini-css-extract-plugin
export default {"container":"OJ-z","dimension":"PJ-z","dimensionLabels":"QJ-z"};